<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/EwKecp/images/9780805088557.jpg?1724781830734" alt="This image is the cover for the book Goodbye Season"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Goodbye Season
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A courageous young woman comes of age in the midst of an historical tragedy, from the author of <i>Dark Water Rising.</i></b><br/><br/>Mercy Kaplan doesn't want to be like her mother, saddled with crying kids and failing crops for the rest of her life. Mercy longs to be on her own—until her wish comes true in the worst possible way. It is 1918 and a deadly flu epidemic ravages the country, leaving her utterly alone and penniless. <br/><br/>Mercy soon finds a job with Mrs. Wilder. But there's something unsettling about the woman, whose brother died under mysterious circumstances. And then there's Daniel, who could sweep a girl off her feet if she isn't careful.<br/><br/>“The history—of the epidemic and of early feminism—creates a dramatic story, and Mercy’s personal struggle for independence is universal.” —<i>Booklist</i><br/><br/>“Mercy tells her story in a gentle, cadenced voice filled with youthful hope, simple wisdom and gritty endurance. Perfect similes capture the flavor of Mercy's bittersweet life during the epidemic of 1918.” —<i>Kirkus Reviews</i></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Marian Hale
      </h2>
      
      <p class="authorDescription body article"><P><B>Marian Hale</B> is the author of acclaimed historical novels for young adults including <I>The Truth About Sparrows</I> and <I>Dark Water Rising</I>. She lives with her husband, daughter, and grandbabies on the Texas Coast.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Henry Holt and Company
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?02f398c7